export default __webpack_public_path__ + "static/media/grupos.7db22727.png";